import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Dashboard from '../pages/Dashboard';
import NoActiveMembership from './NoActiveMembership';
import { resolveDashboardLanding } from './dashboardRouting';

/**
 * Index/dashboard wrapper. For parent-active sessions the dashboard is the
 * /parent tree (kid-as-frame); the legacy Dashboard with location-scoped
 * stats no longer applies. ParentHomeRedirect inside /parent picks the
 * right per-kid or all-kids landing.
 *
 * Hybrid users (staff + parent) have a role switcher, so a switch to a
 * non-parent role reroutes here and naturally drops them onto Dashboard.
 *
 * A user authenticated with no active membership (a parent whose invite-signup
 * isn't finished, so their membership is still dormant) gets a clear
 * onboarding-pending state rather than the staff Dashboard, whose API calls
 * would 403.
 */
const DashboardOrParent: React.FC = () => {
  const { isParent, isSuperAdmin, user } = useAuth();
  const landing = resolveDashboardLanding({
    isParent,
    isSuperAdmin,
    membershipCount: user?.memberships?.length ?? 0,
  });

  if (landing === 'parent') {
    return <Navigate to="/parent" replace />;
  }
  if (landing === 'no-membership') {
    return <NoActiveMembership />;
  }
  return <Dashboard />;
};

export default DashboardOrParent;
